import React from "react";
import { BaseLayout } from "../../layouts";
import { MapList } from "../../components";
var MapPage = function (props) {
    return (React.createElement(BaseLayout, null,
        React.createElement(MapList, null)));
};
export default MapPage;
//# sourceMappingURL=MapPage.js.map